module.exports = __webpack_public_path__ + "static/testimonials_background-2f784d06a9e0fd040d52a4ac7d63ea8f.png";